import { LinearProgress } from "@mui/material";
import { useState } from "react";

const ForgotPasswordComp = (props) => {
  const {
    showLoader,
    isSentResetLink,
    setForgetEmail,
    forgetEmailError,
    sendForgotPassLink,
    handleShow,
    setIsForgotPassClick,
  } = props;

  const [email, setEmail] = useState("");

  const handleEmail = (e) => {
    setForgetEmail(e.target.value);
    setEmail(e.target.value);
  };

  return (
    <>
      <div className="fprdm">
        {showLoader ? <LinearProgress /> : ""}

        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="row">
                {isSentResetLink ? (
                  <div className="col backGround">
                    <div className="icon-box text-center">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_3752_2008)">
                          <rect
                            x="2"
                            y="1"
                            width="56"
                            height="56"
                            rx="12"
                            fill="white"
                          />
                          <rect
                            x="2.5"
                            y="1.5"
                            width="55"
                            height="55"
                            rx="11.5"
                            stroke="#EAECF0"
                          />
                          <path
                            d="M18.334 23.1641L27.8597 29.8321C28.6311 30.372 29.0168 30.642 29.4363 30.7466C29.8069 30.839 30.1944 30.839 30.565 30.7466C30.9845 30.642 31.3702 30.372 32.1416 29.8321L41.6673 23.1641M23.934 38.3307H36.0673C38.0275 38.3307 39.0076 38.3307 39.7563 37.9493C40.4149 37.6137 40.9503 37.0783 41.2858 36.4197C41.6673 35.671 41.6673 34.6909 41.6673 32.7307V25.2641C41.6673 23.3039 41.6673 22.3238 41.2858 21.5751C40.9503 20.9165 40.4149 20.3811 39.7563 20.0455C39.0076 19.6641 38.0275 19.6641 36.0673 19.6641H23.934C21.9738 19.6641 20.9937 19.6641 20.245 20.0455C19.5865 20.3811 19.051 20.9165 18.7155 21.5751C18.334 22.3238 18.334 23.3039 18.334 25.2641V32.7307C18.334 34.6909 18.334 35.671 18.7155 36.4197C19.051 37.0783 19.5865 37.6137 20.245 37.9493C20.9937 38.3307 21.9738 38.3307 23.934 38.3307Z"
                            stroke="#344054"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_3752_2008"
                            x="0"
                            y="0"
                            width="60"
                            height="60"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_3752_2008"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_3752_2008"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                    <h2 className="forgot-title text-center">
                      Check your email
                    </h2>
                    <p className="text-left">
                    If we find a match, you'll get an email with further instructions. If you don't hear from us in the next 15 minutes, please double check that you entered the correct email address.
                      {false && <strong>{email}</strong>}
                    </p>
                    {true && <div className="don-have-account mt-4 mb-4">
                      Didn’t receive the email? <strong className="cursor-pointer" onClick={() => sendForgotPassLink()}>Click to resend</strong>
                    </div>}
                    <p
                      className="text-center cursor-pointer mt-4 pt-2 bck-login"
                      onClick={() => {
                        setIsForgotPassClick(false);
                        handleShow(false);
                      }}
                       style={{color:"#6941c6"}}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M16.3327 9.9974H4.66602M4.66602 9.9974L10.4993 15.8307M4.66602 9.9974L10.4993 4.16406"
                          stroke="#475467"
                          strokeWidth="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>{" "}
                      {"Back to sign in"}
                    </p>
                    {/* <div className="alert-forgot-message">
                      <span className="alertforgot-cion">i</span>
                      <span className="text-alert-msg">
                        If we find a match, you'll get an email with further
                        instructions. If you don't hear from us in the next 15
                        minutes, please double check that you entered the
                        correct email address.
                      </span>
                    </div> */}
                  </div>
                ) : (
                  <div className="col backGround">
                    <div className="icon-box text-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <path
                          d="M19.8333 10.4999C19.8333 9.9028 19.6055 9.30568 19.1499 8.85008C18.6943 8.39447 18.0972 8.16667 17.5 8.16667M17.5 17.5C21.366 17.5 24.5 14.366 24.5 10.5C24.5 6.63401 21.366 3.5 17.5 3.5C13.634 3.5 10.5 6.63401 10.5 10.5C10.5 10.8193 10.5214 11.1336 10.5628 11.4415C10.6309 11.948 10.6649 12.2013 10.642 12.3615C10.6181 12.5284 10.5877 12.6184 10.5055 12.7655C10.4265 12.9068 10.2873 13.046 10.009 13.3243L4.04673 19.2866C3.84496 19.4884 3.74407 19.5893 3.67192 19.707C3.60795 19.8114 3.56081 19.9252 3.53224 20.0442C3.5 20.1785 3.5 20.3212 3.5 20.6065V22.6333C3.5 23.2867 3.5 23.6134 3.62716 23.863C3.73901 24.0825 3.91749 24.261 4.13701 24.3728C4.38657 24.5 4.71327 24.5 5.36667 24.5H8.16667V22.1667H10.5V19.8333H12.8333L14.6757 17.991C14.954 17.7127 15.0932 17.5735 15.2345 17.4945C15.3816 17.4123 15.4716 17.3819 15.6385 17.358C15.7987 17.3351 16.052 17.3691 16.5585 17.4372C16.8664 17.4786 17.1807 17.5 17.5 17.5Z"
                          stroke="#344054"
                          strokeWidth="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <h2 className="forgot-title text-center">
                      Forgot password?
                    </h2>
                    <div className="pop_modal_body">
                      {/* <h4>Forgot Password</h4> */}
                      <p>No worries, we'll send you reset instructions.</p>
                      <div className="input-text position-relative">
                        <label htmlFor="email" className="input__label">
                          Email
                        </label>
                        <input
                          className="input__field passwordforgt_input"
                          id="email"
                          type="email"
                          placeholder="Enter your email address"
                          onChange={handleEmail}
                          autoComplete="off"
                        />
                        <div className="mb-2 login-msg">
                          <div style={{ color: "red" }}>{forgetEmailError}</div>
                        </div>
                      </div>
                    </div>
                    <div className="forget_btn">
                      <button
                        className="default-btn signinBtn mt-4"
                        onClick={() => sendForgotPassLink()}
                      >
                        Reset Password
                      </button>
                      <br />
                      <p
                        className="cursor-pointer mt-4 pt-2"
                        style={{color:"#6941c6"}}
                        onClick={() => {
                          setIsForgotPassClick(false);
                          handleShow(false);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M16.3327 9.9974H4.66602M4.66602 9.9974L10.4993 15.8307M4.66602 9.9974L10.4993 4.16406"
                            stroke="#475467"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        {"Back to sign in"}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPasswordComp;
